// @flow

import React from 'react';
import ListPage from 'esm-web-pro/containers/pages/ListPage';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';
import { Route, Switch } from 'react-router';
import { More } from 'grommet-icons';
import ActionsColumn from 'speed-js-react-web/src/components/grommet2/tables/columns/Action/ActionsColumn';
import { BooleanColumn } from 'speed-js-react-web';
import NomenclatureTypeSidePanel from 'esm-web-pro/components/pages/nomenclatures/sidepanel/NomenclatureTypeSidePanel';
import QuickViewIcon from 'esm-web-pro/components/icons/QuickViewIcon';
import NomenclatureTypeDashboard from 'esm-web-pro/components/pages/nomenclatures/NomenclatureTypeDashboard';
import TaskType from 'esm-web-pro/components/pages/nomenclatures/sidepanel/EscalationMatricesTaskType';

const NOMENCLATURE_SIDEPANEL_KEY = 'NOMENCLATURE_TYPE_ID';


const columns = (reloadData) => [
    {
        Header: <FormattedMessage id="name" defaultMessage="Name" />,
        accessor: 'translations.bg.name',
        orderBy: 'name',
        minWidth: 120,
    },
    {
        Header: <FormattedMessage id="nomenclature-code" defaultMessage="Code" />,
        accessor: 'code',
        minWidth: 120,
    },
    {
        Header: <FormattedMessage id="nomenclature-is-active" defaultMessage="Is active" />,
        accessor: 'is_active',
        minWidth: 70,
        Cell: BooleanColumn,
    },
    {
        actions: [{
            label: <FormattedMessage id="dashboard-action" defaultMessage="Dashboard" />,
            to: '/administration/nomenclatures/types/{id}/dashboard',
            type: 'link',
            icon: <More />,
        }, {
            label: <FormattedMessage
                id="projmanag-counterparties-quickview"
                defaultMessage="Quick View"
            />,
            type: 'quickView',
            accessor: 'id',
            component: NomenclatureTypeSidePanel,
            resourceName: 'nomenclatureType',
            icon: <QuickViewIcon />,
            getTitle: (obj) => obj.translations.bg.name,
            panelId: NOMENCLATURE_SIDEPANEL_KEY,
            reload: reloadData,
        }],
        Cell: ActionsColumn,
        minWidth: 70,
    },
];

const messages = defineMessages({
    nomenclatures: {
        id: 'nomenclature-label-plural',
        defaultMessage: 'Nomenclatures',
    },
});

const NomenclaturesRoutes = () => {
    const listRef = React.useRef(null);
    const { formatMessage } = useIntl();

    const reloadData = () => {
        if (listRef.current && listRef.current.table.current) {
            listRef.current.table.current.reloadData();
        }
    };

    return (
        <Switch>
            <Route
                path="/administration/nomenclatures/escalation-matrices"
                component={TaskType}
            />
            <Route
                path="/administration/nomenclatures/types/:id/dashboard"
                component={NomenclatureTypeDashboard}
            />
            <Route
                path="/administration/nomenclatures/types"
                render={(props) => (
                    <ListPage
                        ref={listRef}
                        {...props}
                        title={formatMessage(messages.nomenclatures)}
                        resourceName="nomenclatureType"
                        permissions={['nomenclatures.view_nomenclaturetype']}
                        columns={columns(reloadData)}
                        // If you need a save and new option button just add saveAndNewOption prop.
                        saveAndNewOption
                        newObjectLabel={(
                            <FormattedMessage
                                id="nomenclature-new-nomenclature-type"
                                defaultMessage="New Nomenclature type"
                            />
                        )}
                        editObjectLabel={(
                            <FormattedMessage
                                id="nomenclature-edit-nomenclature-type"
                                defaultMessage="Edit Nomenclature type"
                            />
                        )}
                    />
                )}
            />
        </Switch>
    );
};

export default NomenclaturesRoutes;
